import { useEffect, useState } from 'react';
import { getIsBrowser } from '../../utils';
export const useIsBrowser = () => {
    const [isBrowser, setIsBrowser] = useState(false);
    useEffect(() => {
        setIsBrowser(getIsBrowser());
    }, []);
    return isBrowser;
};
